import { render, staticRenderFns } from "./requestLicense.vue?vue&type=template&id=16eb3618"
import script from "./requestLicense.vue?vue&type=script&lang=js"
export * from "./requestLicense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports